(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["colour-cards"] && !Shopify.designMode) return;
  try {
    /* <colour-cards>: carousel fitting, edge fades, progress line, tap feedback.
     A custom element so it re-initialises after Horizon re-renders the section. */
  if (!customElements.get('colour-cards')) {
    class ColourCards extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.colour-cards__list');
        this.thumb = this.querySelector('.colour-cards__progress-thumb');
        if (!this.list) return;

        this.onClick = (e) => {
          const link = e.target.closest('.colour-cards__link[href]');
          if (link) link.closest('.colour-cards__item').classList.add('is-loading');
        };
        this.addEventListener('click', this.onClick);

        if (this.dataset.layout !== 'carousel') return;

        this.onScroll = () => this.updateScrollState();
        this.list.addEventListener('scroll', this.onScroll, { passive: true });

        /* Re-fit whenever the available width changes. ResizeObserver covers
           layout changes; window resize + load are belt-and-braces. */
        this.onResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.fit(), 60);
        };
        window.addEventListener('resize', this.onResize);
        window.addEventListener('load', this.onResize);
        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(this.list);

        this.fit();
        requestAnimationFrame(() => this.fit());
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.list && this.onScroll) this.list.removeEventListener('scroll', this.onScroll);
        if (this.onResize) {
          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('load', this.onResize);
        }
        if (this.ro) this.ro.disconnect();
      }

      /* Size the cards so that N fit fully and the next one is cut off by `peek`
         (a fraction of a card). Keeps the width as close as possible to the
         configured desktop / mobile width. */
      fit() {
        const items = this.list.children.length;
        const W = this.list.clientWidth;
        if (!W || !items) return;

        const gap = parseFloat(this.dataset.gap) || 0;
        const desktop = window.matchMedia('(min-width: 750px)').matches;
        const wanted = parseFloat(desktop ? this.dataset.cardW : this.dataset.cardWM) || 80;
        const peek = Math.min(0.6, Math.max(0.15, (parseFloat(this.dataset.peek) || 25) / 100));

        const fitsFully = Math.floor((W + gap) / (wanted + gap));
        if (fitsFully >= items) {
          /* Everything fits - no carousel behaviour needed. */
          this.style.removeProperty('--cc-w-fit');
          this.classList.remove('is-scrollable', 'can-scroll-left', 'can-scroll-right');
          return;
        }

        let best = null;
        for (const n of [fitsFully, fitsFully - 1, fitsFully + 1]) {
          if (n < 1 || n >= items) continue;
          const w = (W - n * gap) / (n + peek);
          const diff = Math.abs(w - wanted) / wanted;
          if (!best || diff < best.diff) best = { w, diff };
        }
        if (!best) {
          /* Only one card would fit with a peek: shrink to show 1 + peek. */
          best = { w: (W - gap) / (1 + peek) };
        }
        this.style.setProperty('--cc-w-fit', best.w.toFixed(2) + 'px');
        this.classList.add('is-scrollable');
        this.updateScrollState();
      }

      updateScrollState() {
        const l = this.list;
        const max = l.scrollWidth - l.clientWidth;
        this.classList.toggle('can-scroll-left', l.scrollLeft > 2);
        this.classList.toggle('can-scroll-right', l.scrollLeft < max - 2);
        if (this.thumb && l.scrollWidth > 0) {
          const ratio = l.clientWidth / l.scrollWidth;
          this.thumb.style.width = (ratio * 100).toFixed(2) + '%';
          this.thumb.style.transform = 'translateX(' + ((l.scrollLeft / l.scrollWidth) * 100 / ratio).toFixed(2) + '%)';
        }
      }
    }
    customElements.define('colour-cards', ColourCards);
  }
  } catch(e) { console.error(e); }
})();

})();
